import React, { useState } from 'react'

const useModalStatus = () => {
    const [isModalOpenStatus, setModalOpenStatus] = useState(false);

    const openModalStatus = () => {
      setModalOpenStatus(true);
    };
  
    const closeModalStatus = () => {
      setModalOpenStatus(false);
    };

    return{
        isModalOpenStatus,
        setModalOpenStatus,
        closeModalStatus,
        openModalStatus
    }
}


export default useModalStatus